var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "form-content", attrs: { id: "wizard-step-3" } },
    [
      _c("sc-form", {
        attrs: { form: _vm.formContent, "has-style": false, rules: _vm.rules },
        on: { submit: _vm.submitNextStep },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c("section", { staticClass: "upload-form" }, [
                  _c("div", { staticClass: "upload-form__step" }, [
                    _c("div", { staticClass: "label" }, [
                      _c("span", { staticClass: "upload-form__step__label" }, [
                        _vm.previewMapIsEmpty()
                          ? _c(
                              "span",
                              [
                                _c(
                                  "sc-tag",
                                  { attrs: { size: "is-medium", rounded: "" } },
                                  [_vm._v("5")]
                                ),
                                _vm._v(
                                  "\n                Identifique a informação de cada coluna\n                "
                                ),
                                _c("p", { staticClass: "additional-label" }, [
                                  _vm._v(
                                    "Agora, digite coluna que representa cada informação."
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "additional-label" }, [
                                  _vm._v(
                                    "Caso não tenha algum dos dados listados, pode deixar em branco."
                                  )
                                ])
                              ],
                              1
                            )
                          : _c("span", [
                              _c("p", { staticClass: "additional-label" }, [
                                _vm._v(
                                  "Confirme se os dados estão corretos para terminar de criar o modelo da fatura."
                                )
                              ])
                            ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "section",
                      { attrs: { id: "billing-template-step-3-fields" } },
                      [
                        _c("div", { staticClass: "columns" }, [
                          _c(
                            "div",
                            { staticClass: "column column-value-config" },
                            [
                              _c("p", { staticClass: "column-header" }, [
                                _vm._v("Nome do dado")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "column",
                              class: {
                                "column-letter-config": !_vm.previewMapIsEmpty()
                              }
                            },
                            [
                              _c("p", { staticClass: "column-header" }, [
                                _vm._v("Coluna")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.previewMapIsEmpty()
                            ? _c(
                                "div",
                                { staticClass: "column column-value-config" },
                                [
                                  _c("p", { staticClass: "column-header" }, [
                                    _vm._v("Nome do dado na fatura")
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.columnsEnum, function(ref) {
                          var key = ref[0]
                          var value = ref[1]
                          return _c("div", [
                            _vm.previewMapIsEmpty() || _vm.previewMap[key]
                              ? _c("div", { staticClass: "columns" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "column column-value-config"
                                    },
                                    [
                                      _vm.previewMap[key] &&
                                      value.hasMultipleTypes
                                        ? [
                                            fields[key].type === "PERCENTAGE"
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass: "column-name"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(value.label) +
                                                        " (%)"
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  {
                                                    staticClass: "column-name"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(value.label) +
                                                        " (R$)"
                                                    )
                                                  ]
                                                )
                                          ]
                                        : [
                                            _c(
                                              "p",
                                              { staticClass: "column-name" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(value.label) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ],
                                      _vm._v(" "),
                                      value.hasMultipleTypes &&
                                      _vm.previewMapIsEmpty()
                                        ? _c(
                                            "sc-field",
                                            {
                                              staticClass: "tax-field",
                                              attrs: {
                                                id: "radio-" + value.label
                                              }
                                            },
                                            [
                                              _c(
                                                "p",
                                                { staticClass: "column-type" },
                                                [_vm._v(" Valor em: ")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "percentage-field"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "radio-label"
                                                    },
                                                    [_vm._v(" % ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("sc-radio", {
                                                    attrs: {
                                                      "native-value":
                                                        "PERCENTAGE"
                                                    },
                                                    model: {
                                                      value: fields[key].type,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          fields[key],
                                                          "type",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields[key].type"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "absolute-field"
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "radio-label"
                                                    },
                                                    [_vm._v(" R$ ")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("sc-radio", {
                                                    attrs: {
                                                      "native-value": "ABSOLUTE"
                                                    },
                                                    model: {
                                                      value: fields[key].type,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          fields[key],
                                                          "type",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields[key].type"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "column",
                                      class: {
                                        "column-letter-config": !_vm.previewMapIsEmpty()
                                      }
                                    },
                                    [
                                      _c(
                                        "sc-field",
                                        {
                                          staticClass: "letter-input",
                                          attrs: {
                                            id: "input-" + key,
                                            prop: key
                                          }
                                        },
                                        [
                                          _c("sc-input", {
                                            staticStyle: {
                                              width: "66px",
                                              height: "39px"
                                            },
                                            attrs: {
                                              disabled: !_vm.previewMapIsEmpty(),
                                              placeholder: "AA"
                                            },
                                            nativeOn: {
                                              input: function($event) {
                                                $event.target.value = $event.target.value
                                                  .toUpperCase()
                                                  .replace(/[^a-zA-Z]/g, "")
                                                  .substring(0, 2)
                                              }
                                            },
                                            model: {
                                              value: fields[key].letter,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  fields[key],
                                                  "letter",
                                                  $$v
                                                )
                                              },
                                              expression: "fields[key].letter"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.previewMapIsEmpty()
                                    ? _c(
                                        "div",
                                        { staticClass: "column" },
                                        [
                                          _vm.previewMap[key] !== "VAZIO"
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "column-name column-preview"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.previewMap[key]
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "sc-field",
                                                {
                                                  attrs: {
                                                    prop: key + "_PREVIEW"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "column-name preview-empty"
                                                    },
                                                    [_vm._v(" Coluna vazia ")]
                                                  )
                                                ]
                                              )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm.previewMapIsEmpty()
                    ? _c(
                        "div",
                        { staticClass: "upload-form__step" },
                        [_c("new-billing-template-image-helper")],
                        1
                      )
                    : _vm._e()
                ])
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _c("section", { staticClass: "continue-buttom" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$emit("onPrevStep")
                        }
                      }
                    },
                    [_vm._v("Voltar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { type: "submit" }
                    },
                    [_vm._v(_vm._s(_vm.buttonText))]
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-272215a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-272215a5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateStep3.vue
// module id = null
// module chunks = 